import { put, takeLatest } from "redux-saga/effects";
import { onGetThemeMaster, onGetThemeMasterError, onGetThemeMasterSuccess } from "../Store/Slices/themeMasterSlice";
function* GetThemeMaster({payload}) {
  try {
    if (payload.status_code === "200") {
      yield put(
        onGetThemeMasterSuccess({
          data: payload.data,
          status_code:payload.status_code,
        })
      );
    } else {
      yield put(
        onGetThemeMasterError({
          data: payload.error || [],
          message: payload.response.message,
          status_code:payload.status_code
        })
      );
    }
  } catch (error) {
    const message = error.response.data.responseMessage  || "Something went wrong";
    yield put(onGetThemeMasterError({ data: [], message, status_code: 400 }));
  }
}

export default function* themeMasterSaga() {
  yield takeLatest(onGetThemeMaster.type, GetThemeMaster);

}
